import { render } from "./IbanValidator.vue?vue&type=template&id=b8a62e9e"
import script from "./IbanValidator.vue?vue&type=script&lang=js"
export * from "./IbanValidator.vue?vue&type=script&lang=js"

import "./IbanValidator.vue?vue&type=style&index=0&id=b8a62e9e&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__